import React,{useState} from 'react'

export default function SocialMediaPopup() {

    const [social,setSocial] = useState(false);

    const displaysocial=()=>{

        setSocial(true);


    };
    const displaysocialup=()=>{

        setSocial(false);
        document.getElementById("socialpop").style.display="none";
        document.getElementById("SocialPopMob").style.display="inline";



    };
    if(social){
        document.getElementById("socialpop").style.display="inline";
        document.getElementById("SocialPopMob").style.display="none";

        
    }
    return (
        <div>
            <div id="socialpop" className="SocialPop">

                <div className="col-12">
                    <div className="socialtag">
                    <li ><a target="_blank" className="twitter" href="https://twitter.com/contactInfoMine"><i class="fab fa-twitter"></i></a></li>

                    </div>
                </div>
                <div className="col-12">
                    <div className="socialtag">
                    <li ><a target="_blank" className="linkedin" href="https://www.linkedin.com/in/infomine-0b22431a9"><i class="fab fa-linkedin"></i></a></li>

                    </div>
                </div>
                <div className="col-12">
                    <div className="socialtag">
                    <li ><a target="_blank" className="facebook" href="https://www.facebook.com/InfoMineofficial"><i class="fab fa-facebook"></i></a></li>

                    </div>
                </div>
                <div className="col-12">
                    <div className="socialtag">
                    <li ><a target="_blank" className="instagram" href="https://www.instagram.com/info.mine"><i  class="fab fa-instagram"></i></a></li>

                    </div>
                </div>
                <div className="col-12 SocialPopMobup">
                    <div className="socialtag">
                    <li ><a onClick={displaysocialup} ><i class="fa fa-angle-up"></i></a></li>

                    </div>
                </div>
                
            </div>
            <div id="SocialPopMob" className="SocialPopMob">

            <div className="col-12">
            <li ><a onClick={displaysocial} ><i class="fa fa-angle-down" aria-hidden="true"></i></a></li>
           </div>

            </div>
            
        </div>
    )
}
